import React, { useEffect, useState } from "react";
import RightNavigation from "../../Views/Navigation/RightNavigation";
// import { NewsFeed, post } from "../../config/imagesLink";
import PostInteractionModal from "../NewsFeed/PostInteractionModal";
import axios from "../../API/axios";
import { Link, NavLink, useParams } from "react-router-dom";
import { ShimmerThumbnail, ShimmerTitle } from "react-shimmer-effects";
import moment from "moment/moment";
import PostEngagement from "../NewsFeed/PostEngagement";
import ImageSliderModal from "../NewsFeed/ImageSliderModal";
import { ArticleDetailSkeleton } from "@skeleton";
import SinglePostEngagement from "../NewsFeed/SinglePostEngagement";
import SinglePostInteraction from "../NewsFeed/SinglePostInteraction";
import SinglePostComment from "../NewsFeed/SinglePostComment";
import LikesDetails from "../NewsFeed/LikesDetails";
import { Helmet } from "react-helmet";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Tag } from "antd";
import PostComponent from "../NewsFeed/PostComponent";
import { useTranslation } from "react-i18next";

import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";

import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Tooltip } from "@mui/material";
import { post } from "../../config/imagesLink";

const ArticleDetail = () => {
  const guestModeData = localStorage.getItem("guestMode");
  const sessionId = localStorage.getItem("sessionId"); 
  const { t } = useTranslation();

  const [article, setArticle] = useState();
  const { PostId, slug } = useParams();
  const [isError, setIsError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const handleCloseModal = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [dLike, setDLike] = useState(0);
  const [singlepostId, setSinglePostId] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [postList, setPostList] = useState([]);
  const [isfollowed, setIsfollowed] = useState(false);
    const language = localStorage.getItem("Lang");
     const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
  
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");

  //Fetching article detail
  useEffect(() => {
    if (!slug) return;

    const fetchArticle = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(
          `/Posts/GetArticleInfo?DeviceType=Web&PostId=${PostId}&TitleSlug=${slug}&langKey=${language}`
          // `/Posts/GetArticleInfo?DeviceType=Web&TitleSlug=${slug}`
        );
        console.log("articleDetailResp", res.data.responseData);
        if (res.status === 204) {
          setIsError(true);
        } else {
        setArticle(res.data.responseData);
        }
      } catch (error) {
        console.error("Error fetching article:", error);
          setIsError(true);

      } finally {
        setIsLoading(false);
      }
    };

    fetchArticle();
  }, [slug]);

  const openModal = (images) => {
    setModalImages(images);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [singlePostContent, setSinglePostContent] = useState("");
  const [ispostmodalOpen, setIspostmodalOpen] = useState(false);
  const [isLiked, setIsLiked] = useState(false);


  const updateLikeCount = (postId, delta) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, likeCount: post.likeCount + delta }
          : post
      )
    );
  };

  const updateCommentCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, commentCount: post.commentCount + change }
          : post
      )
    );
  };

  const updateShareCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, shareCount: post.shareCount + change }
          : post
      )
    );
  };

  const [postLikedType, setPostLikedType] = useState(false);

  const handleShowModal = (item) => {
    // setPostId(item.postId);
    setPostLikedType(item.likedType);
    setShowModal(true);
  };

  const handleLikesCloseModal = () => {
    setShowModal(false);
    // setSelect
    // edItem(null);
  };

  const postId = article?.info?.postInfo?.postId;

  const [singlepostList, setSinglePostList] = useState([]);
    const [singlepostListinfo, setSinglePostListInfo] = useState("");
    const [singlepostCommentList, setSinglePostCommentList] = useState([]); 

  const AllPostData = async () => {
    const Data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`,)
        .then((resData) => {
          setIsLoading(false);
          console.log("resData", resData);
          if (resData.status === 204) {
            setIsError(true);
          } else {
            setSinglePostList(resData.data.responseData);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

const AllPostComments = () => {
    try {
      axios
        .get(`/Posts/LoadAllComments?DeviceType=Web&PostId=${PostId}&langKey=${language}`)
        .then((resData) => {
          // console.log("hiiiiiiiii", resData.data.responseData);

          setSinglePostCommentList(resData.data.responseData);
        });
    } catch (error) {
      console.log(error);
    }
  };
  
  const AllPostList = async () => (
    AllPostData(),
    AllPostComments()
  )

  useEffect(() => {
    AllPostList();
  }, [postId]);

const updatePostLike = (postId, isLikedStatus, likedType) => {
  setSinglePostListInfo((prev) => {
    if (!prev || prev.postInfo?.postId !== postId) return prev;

    return {
      ...prev,
      postInfo: {
        ...prev.postInfo,
        postActionsInfo: {
          ...prev.postInfo.postActionsInfo,
          isLiked: isLikedStatus,
          likedType: likedType,
        },
      },
    };
  });
};

const updateCommentLike = (postId, commentId, action, likeType = null) => {
  setSinglePostListInfo((prev) => {
    if (!prev || prev.postInfo?.postId !== postId) return prev;

    return {
      ...prev,
      postInfo: {
        ...prev.postInfo,
        comments: (prev.postInfo.comments || []).map((c) => {
          if (c.pstCmntId !== commentId) return c;

          if (action === "like") {
            return {
              ...c,
              likeCount: (c.likeCount || 0) + 1,
              isLiked: true,
              likedType: likeType,
            };
          }

          if (action === "unlike") {
            return {
              ...c,
              likeCount: Math.max((c.likeCount || 1) - 1, 0),
              isLiked: false,
              likedType: null,
            };
          }

          if (action === "change") {
            return {
              ...c,
              isLiked: true,
              likedType: likeType,
            };
          }

          return c;
        }),
      },
    };
  });
};

  const updateReplyCommentLike = (postId, commentId, replyId, action, likeType = null) => {
  setSinglePostListInfo((prev) => {
    if (!prev || prev.postInfo?.postId !== postId) return prev;

    return {
      ...prev,
      postInfo: {
        ...prev.postInfo,
        comments: (prev.postInfo.comments || []).map((c) => {
          if (c.pstCmntId !== commentId) return c;

          return {
            ...c,
            commentsReplies: (c.commentsReplies || []).map((reply) => {
              if (reply.pstCmntRplyId !== replyId) return reply;

              if (action === "like") {
                return {
                  ...reply,
                  isLiked: true,
                  likeCount: (reply.likeCount || 0) + 1,
                  likedType: likeType,
                };
              }

              if (action === "unlike") {
                return {
                  ...reply,
                  isLiked: false,
                  likeCount: reply.likeCount > 0 ? reply.likeCount - 1 : 0,
                  likedType: null,
                };
              }

              if (action === "change") {
                return {
                  ...reply,
                  likedType: likeType,
                };
              }

              return reply;
            }),
          };
        }),
      },
    };
  });
};
  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => { 
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };
  // console.log("singlepostList", singlepostList);

  // const replaceDynamicValues = (content, dynamicValues) => {
  //   if (!content || !dynamicValues) return content;

  //   dynamicValues.forEach((item) => {
  //     const placeholder = `{${item.dVno}}`;
  //     const replacement =
  //       item.type === "UserMention"
  //         ? `<a href="/user/${item.entityID || item?.entity}" class="user-mention">@${item.displayName || item?.display}</a>`
  //         : item.type === "Hashtag"
  //         ? `<a href="/hashtag/${item.displayName || item?.display}" class="hashtag">#${item.displayName || item?.display}</a>`
  //         : item.displayName;

  //     content = content.replaceAll(placeholder, replacement);
  //   });

  //   return content;
  // };
  const replaceDynamicValues = (content, dynamicValues) => {
    console.log("dynamicValues", dynamicValues);
    if (!content || !dynamicValues) return content;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
        const displayName = item.displayName ?? item.display ?? "";
        const entityId = item.entity ?? item.entityID ?? "";
       const replacement =
        item.type === "UserMention"
          ? `<a href="/user/${entityId}" class="user-mention" targget="_blank">@${displayName}</a>`
          : item.type === "Hashtag"
            ? `<a href="/hashtag/${displayName}" class="hashtag" targget="_blank">#${displayName}</a>`
            : item.type === "CompanyMention"
              ? `<a href="/Company/${entityId}" class="hashtag" targget="_blank">@${displayName}</a>`
              : item.displayName;


      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };
  const formattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        singlepostList?.postInfo?.postInfo?.postContent,
        singlepostList?.postInfo?.postInfo?.dynamicValues
      )
    )
  );

  const ArticleFormattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        article?.info?.postInfo?.postContent,
        article?.info?.postInfo?.dynamicValues
      )
    )
  );

  const [openBgModal, setOpenBgModal] = useState(false);
  const handleOpen = () => {
    setOpenBgModal(true);
  };

  const handleOpenBgCloseModal = () => {
    setOpenBgModal(false);
  };

  useEffect(() => {
    if (openBgModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [openBgModal]);

  console.log("consoling singlepost", singlepostList)

   const getRelativeTime = (item) => {
  console.log("consolingsinglepost", item)

  const now = moment.utc().local();
  const itemTime = moment
    .utc(item?.postInfo?.creationTime)
    .local();

  const diffSeconds = now.diff(itemTime, "seconds");
  const diffMinutes = now.diff(itemTime, "minutes");
  const diffHours = now.diff(itemTime, "hours");
  const diffDays = now.diff(itemTime, "days");
  const diffMonths = now.diff(itemTime, "months", true);
  const diffYears = now.diff(itemTime, "years", true);

  /* JUST NOW */
  if (diffSeconds < 60) {
    return t("Notifications.Just Now");
  }

  /* MINUTES */
  if (diffMinutes < 60) {
    return diffMinutes === 1
      ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
      : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
  }

  /* HOURS */
  if (diffHours < 24) {
    return diffHours === 1
      ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
      : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
  }

  /* DAYS */
  if (diffDays < 30) {
    return diffDays === 1
      ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
      : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
  }

  /* MONTHS */
  if (diffMonths < 12) {
    const displayMonth =
      diffMonths >= 0.75 && diffMonths < 1.25
        ? 1
        : Math.round(diffMonths * 2) / 2;

    return displayMonth === 1
      ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
      : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
  }

  /* YEARS */
  const displayYear =
    diffYears >= 0.75 && diffYears < 1.25
      ? 1
      : Math.round(diffYears * 2) / 2;

  return displayYear === 1
    ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
    : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
};
  return (
    <>
      <Helmet>
        <title> {`${article?.info?.postInfo?.userName} `} || Welinkjobs</title>
        <meta name="description" content="How to create an effective resume" />
        <meta name="keywords" content="newsfeed, updates, latest news" />
        <meta property="og:title" content="John Doe Profile | Welinkjobs" />
        <meta
          property="og:description"
          content="How to create an effective resume"
        />
        <meta property="og:url" content="https://welinkjobs.com/NewsFeeds" />
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113"
        ></script>
      </Helmet>
      {isLoading ? (
            <ArticleDetailSkeleton className="mt-3" />
      ): 
       isError ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <img src={post.errorSmall} alt="404 Not Found" width={200} />
        </div>
      ) : (
        <div className="row w-100 m-0 singlePostLink articlesDetails">
          <div className="col-md-8 p-md-0 p-2">
            <div className="Profilebackground mt-2">
              {/* <div className="background-overlay" onClick={() => handleOpen()}> */}
              <div className="background-overlay-article" >
                <img
                  src={
                    article?.info?.postInfo?.mediaFilesList?.[0]
                      ?.mediaName || "fallback-image-url.jpg"
                  }
                  alt="Background"
                />
              </div>
            </div>
            <h2 className="fw-600 pt-4">
              {article?.info?.postInfo?.articleInfo?.title}
            </h2>

            <div className="Article-Tags">
              {article?.articleTags_Name?.length > 0
                ? article.articleTags_Name.map((tag, index) => (
                    <Tag key={index} color="blue">
                      {tag.replace(/[\[\]"]/g, "").trim()}
                    </Tag>
                  ))
                : ""}
            </div>

            <div
              className="article-content py-md-4 "
              dangerouslySetInnerHTML={{
                __html: article?.info?.postInfo?.postContent,
                
                // __html: ArticleFormattedContent,
              }}
            ></div>
          </div>

          <div
            className="col-md-4 p-0"
            style={{
              // overflowY: "auto",
              maxHeight: "90vh",
              // position: "sticky",
              top: "70px",
            }}
          >
            <div className="featured-card user-postOnlyContent p-2 m-2">
              <div className="feature-content p-2 d-flex justify-content-between">
                <Link to="/Company/123456">
                  <div className="d-flex align-items-center">
                    <div className="ImgAvatar">
                      <img
                        src={article?.info?.postInfo?.userAvatar}
                        alt="Article Publisher Profile Image"
                        style={{ borderRadius: "50px" }}
                      />
                    </div>
                    <div className="ms-2">
                      <h4 className="f-14 fw-bold mb-0">
                        {article?.info?.postInfo?.userName}
                      </h4>
                      {/* <p className="f-12">
                        {moment
                          .utc(article?.info?.postInfo?.creationTime)
                          .local()
                          .format("DD MMMM YYYY [at] h:mm a")}
                      </p> */}
                          {language === "ar" ? (
                                                  <Tooltip title={moment
                                                  .utc(article?.info?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                              <p className="f-10 label"> 
                                                {moment
                                                  .utc(article?.info?.postInfo?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a")}
                                              </p>
                                           </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                                  .utc(article?.info?.postInfo?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <p className="f-10 label"> 
                                          {getRelativeTime(article?.info)}</p>
                                           </Tooltip>
                                            

                                        )}

                    </div>
                  </div>
                </Link> 

                          {guestModeData === "true" ? null : (
                            <div className="row">
                              <div>
                                <SinglePostInteraction
                                  postId={article?.info?.postInfo?.postId}
                                  AllPostList={AllPostList}
                                  singlepostList={singlepostList?.postInfo?.postInfo}
                                  singlepostListData={singlepostList?.postInfo}
                                  postList={postList}
                                  setArticle={setArticle}
                                  article={article}
                                  restrictedViewerToken={restrictedViewerToken}
                                  setPostList={setPostList}
                                  ispostmodalOpen={ispostmodalOpen}
                                  setSinglePostList={setSinglePostList}
                                  PostOriginType={"User"}
                                   postOriginId={singlepostList?.postInfo?.postInfo?.userUid} 
                                    isfollowed={isfollowed}
                                    setIsfollowed={setIsfollowed}

                                />
                              </div>
                            </div>
                          )}
              </div>

              {/* <div className="f-14 p-2 postContent">
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      "Looking for experienced software developers to join our growing team! We offer competitive benefits and remote work options. <a href='https://example.com/jobs'>Click here</a> to learn more about the position and apply.",
                  }}
                />
              </div> */}
              {/* {article?.info?.postInfo?.postContent && (
                <div className="f-14 p-2 postContent">
                  <div dangerouslySetInnerHTML={{
                     __html: formattedContent 
                     }} />
                </div>
              )}  */}

              <div className="feed-post p-2">
                {guestModeData === "true" ? null : (
                  <div className="row">
                    <div className="addComment">
                      <SinglePostComment
                        postId={article?.info?.postInfo?.postId}
                        AllPostList={AllPostList}
                        singlepostList={singlepostList?.postInfo}
                        setSinglePostList={setSinglePostList}
                        ispostmodalOpen={ispostmodalOpen}
                        setIspostmodalOpen={setIspostmodalOpen}
                        setPostList={setPostList}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`postData d-flex align-items-center ${
                  article?.info?.postInfo?.likeCount === 0 &&
                  article?.info?.postInfo?.commentCount === 0 &&
                  article?.info?.postInfo?.shareCount === 0
                    ? ""
                    : "border-custom1"
                }`}
              >
                <div className="ms-2">
                  {article?.info?.postInfo?.likeCount === 0 || article?.info?.postInfo?.likeCount === null ? (
                    ""
                  ) : (
                    <p
                      className="f-10 like-details"
                      onClick={() =>
                        handleShowModal(article?.info?.postInfo)
                      }
                    >
                      {article?.info?.postInfo?.likeCount + dLike} <ThumbUpOutlinedIcon   style={{color:"#00419f", fontSize: "13px"}}/>
                      {/* {t("Newsfeed.Like")} */}
                    </p>
                  )}
                </div>
                <div className="ms-auto d-flex">
                  {article?.info?.postInfo?.commentCount === 0 || article?.info?.postInfo?.commentCount === null ? (
                    ""
                  ) : (
                    <p className="f-10 me-2 pointer">
                      {article?.info?.postInfo?.commentCount} <ChatOutlinedIcon 
                                                              style={{color:"#00419f", fontSize: "13px"}}/>
                      {/* {t("Newsfeed.Comment")} */}
                    </p>
                  )}

                  {/* <p className="f-10">
                    {article?.info?.postInfo?.shareCount === 0 || article?.info?.postInfo?.shareCount === null
                      ? ""
                      : `&  ${article?.info?.postInfo?.shareCount} ${t("Newsfeed.Share")}`}
                    </p> */}
                      <p className="f-10">
                        {article?.info?.postInfo?.shareCount === 0 || article?.info?.postInfo?.shareCount === null
                            ? ""
                            : `&  ${article?.info?.postInfo?.shareCount}`} {article?.info?.postInfo?.shareCount === 0 || article?.info?.postInfo?.shareCount === null
                            ? ""
                             : <ReplyAllOutlinedIcon className=" ms-1" style={{color:"#00419f",fontSize: "13px"}} />
                         }
                       </p>                 
                </div>
              </div> 
              <div className="postengagement">
                <SinglePostEngagement
                 setIsLiked={setIsLiked}
                  isLiked={isLiked}
                  isOwnedPost={article?.info?.postInfo?.isOwned}
                  postId={article?.info?.postInfo?.postId}
                  AllPostList={AllPostList}
                   AllPostComments={AllPostComments}
                  singlepostList={singlepostList}
                  item={singlepostList}
                  setSinglePostList={setSinglePostList}
                  ispostmodalOpen={ispostmodalOpen}
                  setIspostmodalOpen={setIspostmodalOpen}
                  openModal={openModal}
                  setSinglePostId={setSinglePostId}
                  setSinglePostContent={setSinglePostContent}
                  setDLike={setDLike}
                  updateLikeCount={updateLikeCount}
                  setSinglePostCommentList={setSinglePostCommentList}
                  singlepostCommentList={singlepostCommentList}
                  singlepostListinfo={singlepostListinfo}
                  setSinglePostListInfo={setSinglePostListInfo}
                  updateCommentLike={updateCommentLike}
                  updatePostLike={updatePostLike}
                  updateReplyCommentLike={updateReplyCommentLike}
                  updateShareCount={updateShareCount}
                  updateCommentCount={updateCommentCount}
                />
                <LikesDetails
                  showModal={showModal}
                  handleLikesCloseModal={handleLikesCloseModal}
                  postId={article?.info?.postInfo?.postId}
                  postLikedType={postLikedType}
                  setShowModal={setShowModal}
                />
              </div>
            </div>
          </div>
        </div>
      ) } 

      {openBgModal && (
        <div
          className="modal fade show postAdd modal-lg"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
          size="lg"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6> {t("modals.Company Background View")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => handleOpenBgCloseModal()}
                />
              </div>
              <div className="p-2">
                <div className="backrgound-profile-view d-flex justify-content-center">
                  <img
                    src={
                      article?.info?.postInfo?.mediaFilesList?.[0]
                        ?.mediaName || "fallback-image-url.jpg"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ArticleDetail;
